// GT Stage 1 — pagina de produs (sections/gt-pdp-main.liquid).
// Galerie (mobil: glisare + puncte + contor) · „Adaugă în coș” = 1 bucată, un singur /cart/add.js + CartLinesUpdateEvent
// (sertarul coșului se deschide ca la butonul temei); oferta 2+1 / 4+2 e doar explicată (R9.5), reducerea o face coșul
// · bara lipită jos pe mobil = prețul unitar + buton. Logica de coș e portată din assets/nubra-pdp.js (Nubra 2.0).
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

let eventsMod = null;
const eventsReady = import('@shopify/events').then((m) => (eventsMod = m)).catch(() => null);

class GtPdp {
  constructor(root) {
    this.root = root;
    try {
      this.cfg = JSON.parse(root.querySelector('[data-gtp-config]')?.textContent || '{}');
    } catch {
      this.cfg = {};
    }
    this.t = this.cfg.t || {};
    this.$ = (s) => root.querySelector(s);
    this.gallery();
    this.bind();
    this.sticky();
  }

  gallery() {
    const track = this.$('[data-gtp-track]');
    if (!track) return;
    this.track = track;
    this.gi = 0;
    const dots = [...this.root.querySelectorAll('.gtp-dots i')];
    const cur = this.$('[data-gtp-cur]');
    const onScroll = () => {
      if (track.scrollWidth <= track.clientWidth + 2) return; // desktop: grilă, fără glisare
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === this.gi) return;
      this.gi = i;
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
      if (cur) cur.textContent = String(i + 1);
    };
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      const n = track.children.length;
      const i = Math.max(0, Math.min(n - 1, this.gi + (e.key === 'ArrowRight' ? 1 : -1)));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      e.preventDefault();
    });
  }

  bind() {
    this.$('[data-gtp-form]')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.buy();
    });
    this.$('.gtp-sbar [data-gtp-buy]')?.addEventListener('click', (e) => {
      e.preventDefault();
      this.buy();
    });
    // Black Friday 1+1 (caseta specială): „Adaugă 2” sau „adaug acesta și aleg al doilea din selecție”
    this.root.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-gtp-bf11]');
      if (!b || b.disabled || !this.cfg.available) return;
      e.preventDefault();
      const ok = await this.addItems([{ id: Number(this.cfg.variant), quantity: Number(b.dataset.qty) || 1 }], fill(this.t.ok, { produs: this.cfg.name }));
      if (ok && b.dataset.go) window.location.href = b.dataset.go;
    });
  }

  buy() {
    if (!this.cfg.available) return;
    this.addItems([{ id: Number(this.cfg.variant), quantity: 1 }], fill(this.t.ok, { produs: this.cfg.name }));
  }

  sectionIds() {
    return [...document.querySelectorAll('cart-items-component')].map((c) => c instanceof HTMLElement && c.dataset.sectionId).filter(Boolean);
  }

  async addItems(items, okMsg) {
    await eventsReady;
    const btns = [...this.root.querySelectorAll('[data-gtp-buy]')];
    btns.forEach((b) => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    const msg = this.$('[data-gtp-msg]');
    if (msg) msg.textContent = '';
    const routes = window.Theme?.routes || {};
    let deferred = null;
    if (eventsMod?.CartLinesUpdateEvent) {
      const { CartLinesUpdateEvent } = eventsMod;
      deferred = CartLinesUpdateEvent.createPromise();
      this.root.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity })),
        promise: deferred.promise,
      }));
    }
    try {
      const res = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: this.sectionIds().join(',') }),
      }).then((r) => r.json());
      if (res.status) throw Object.assign(new Error(res.description || res.message || 'add'), { res });
      const cart = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: eventsMod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'gt-pdp', sourceId: this.root.id, itemCount: items.reduce((s, it) => s + it.quantity, 0), productId: String(this.cfg.handle), sections: res.sections, didError: false },
        });
      } else {
        window.location.href = routes.cart_url || '/cart';
      }
      if (!document.querySelector('cart-drawer-component[auto-open], [auto-open]')) this.toast(okMsg);
      return true;
    } catch (error) {
      if (deferred) deferred.reject(error);
      if (eventsMod?.CartErrorEvent) this.root.dispatchEvent(new eventsMod.CartErrorEvent({ error: error?.message || 'Add to cart failed', code: error?.res ? 'INVALID' : 'SERVICE_UNAVAILABLE' }));
      const text = error?.res?.description || this.t.err;
      if (msg) msg.textContent = text; else this.toast(text);
      return false;
    } finally {
      btns.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
    }
  }

  toast(text) {
    const t = this.$('[data-gtp-toast]');
    if (!t || !text) return;
    t.textContent = text;
    t.classList.add('show');
    clearTimeout(this._toast);
    this._toast = setTimeout(() => t.classList.remove('show'), 2600);
  }

  sticky() {
    const bar = this.$('[data-gtp-sbar]');
    const atc = this.$('.gtp-form .gtp-atc');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([en]) => {
      // vizibilă oricând butonul principal nu e în ecran (sub galerie la încărcare, sau deja derulat)
      const show = !en.isIntersecting;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('button')?.setAttribute('tabindex', show ? '0' : '-1');
    });
    io.observe(atc);
  }
}

function boot() {
  document.querySelectorAll('[data-gtp]').forEach((el) => {
    if (el.__gtp) return;
    el.__gtp = new GtPdp(el);
  });
}
boot();
document.addEventListener('shopify:section:load', boot);
